var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartOver({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 13C1 19.6273 6.37273 25 13 25C19.6273 25 25 19.6273 25 13C25 6.37164 19.6273 1 13 1C6.37273 1 1 6.37164 1 13V13Z",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8184 8.63601H16.8184C20.0911 8.63601 21.182 11.6807 21.182 14.0906C21.182 16.5015 19.5456 18.4542 19.5456 18.4542V15.7269C19.5456 14.636 19.0002 14.0906 16.8184 14.0906H10.8184V17.3633L4.81836 11.3633L10.8184 5.36328V8.63601V8.63601Z",
    stroke: "white",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartOver);
export default __webpack_public_path__ + "static/media/startOver.a564da54094c24cc0b0b3bfa3735cfc9.svg";
export { ForwardRef as ReactComponent };